import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS } from "../apiEndpoints";

export const addCreditsApi = (userId, creditsToAdd) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.ADD_CREDITS}`,
    { userId, creditsToAdd },
    { headers: { "Content-Type": "application/json" } },
  );

export const deductCreditsApi = (userId, creditsToDeduct, event) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.DEDUCT_CREDITS}`,
    {
      userId,
      creditsToDeduct,
      event,
    },
  );

export const renewCreditsApi = (userId, planTitle) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.RENEW_CREDITS}`,
    {
      userId,
      planTitle,
    },
  );

export const getCreditHistoryApi = (userId, startDate, endDate) =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.GET_CREDIT_HISTORY}`,
    {
      userId,
      startDate,
      endDate,
    },
  );
